﻿(function (angular, ToyotaConsts) {
  "use strict";

  angular.module("Toyota.Factories").factory("Postcodes", [
    "$q",
    "$filter",
    "API",
    function ($q, $filter, API) {
      return function (searchTerm, maxResults) {

        var search = searchTerm.trim();

        if (!search) {
          return $q.when();
        }
        else if (!(ToyotaForms.RegularExpressions.SuburbPostcodePattern.test(search))) {
          return $q.reject();
        }

        var address = $filter("formatArgs")(ToyotaConsts.API.Address.AutoComplete.DealerAddressBySuburbPostcode, [
          encodeURIComponent(search),
          maxResults,
        ]);

        var deferred = $q.defer();

        API.get(address).then(
          function (req) {
            var tags = [];
            var uniqIdent = 0;

            req.data.results.forEach(function (obj) {
              tags.push({
                text: `${obj.suburb}, ${obj.postCode} ${obj.state}`,
                id: uniqIdent++,
                tagInfo: angular.extend({}, obj),
              });
            });

            deferred.resolve(tags);
          },
          function () {
            deferred.resolve([]);
          }
        );

        return deferred.promise;
      };
    },
  ]);
})(window.angular, window.ToyotaConsts);
